import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();
export const getLeadCaptureForms = (params: any) => {
    return axios({
      method: "GET",
      url: "/lead-capture",
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

export const createLeadCaptureForms = (data: unknown, id: any) => {
  return axios({
    method: id ? "PUT":"POST",
    url: id ? `/lead-capture/${id}`: "/lead-capture",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const shareLeadCaptureForms = (data: unknown, id: any) => {
  return axios({
    method: "POST",
    url: `/lead-capture/leadCaptureForm/${id}/share`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const deleteForm = (formId: number ) => {
  return axios({
    method: "DELETE",
    url: `/lead-capture/${formId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};